import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {KtCogsFilterService} from './kt-cogs-filter.service';
import {IKtCogsListItem} from '../interfaces/kt-trip.interface';

@Injectable({providedIn: 'root'})
export class KtCogsGridService implements GridGetService<IKtCogsListItem> {
  private readonly baseUrl = 'tmt/sales-orders/kt-cogs';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(KtCogsFilterService);

  public salesOrderId: number | null = null;

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<IKtCogsListItem>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',
      tripReference: filters?.TripReference ?? '',
      vendorName: filters?.VendorName ?? '',
      productTypeName: filters?.ProductTypeName ?? '',
      ...(this.salesOrderId ? {salesOrderId: this.salesOrderId} : {}),
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IKtCogsListItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
